import { ReactComponent as AccountIcon } from '../../res/icon/Account.svg';
import {useDispatch} from "react-redux";
import {setBusinessPartner} from "../../redux/slice/authSlice";

const BusinessPartnerSelectCard = ({bPartner, onBPSelected}) => {

    return (
        <div className="bp-select-card" onClick={() => onBPSelected(bPartner)}>
            <AccountIcon />
            <p className="bp-select-code">{bPartner.Value}</p>
            <p className="bp-select-name">{bPartner.Name}</p>
        </div>
    )

}

const BusinessPartnerSelect = ({ session }) => {

    const dispatch = useDispatch();

    const onBPSelected = (bp) => {
        dispatch(setBusinessPartner({...bp}))
    }

    return (
        <div className="bp-select">
            <p><span>Welcome back, {session.userName}!</span> Please select a business:</p>
            <div className="bp-select-options">
                {session.accessibleBPs.map(bp =>
                    <BusinessPartnerSelectCard
                        bPartner={bp}
                        onBPSelected={onBPSelected}
                    />
                )}
            </div>
        </div>
    )

}

export default BusinessPartnerSelect;